import React from "react"
import ButtonPrimary from "../buttons/ButtonPrimary"
import { openPopupWidget } from "react-calendly"
import { CALENDLY_URL } from "../../utils/constants"

const MediumCTA = () => {
  const handleClick = () => {
    openPopupWidget({
      url: CALENDLY_URL,
    })

    typeof window !== "undefined" &&
      window.gtag("event", "main_button_click", { from: "Inner Page" })
  }

  return (
    <div className="windowed bg-darkBlue-900 mt-6 md:mt-12">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-20 lg:px-8 lg:flex lg:items-center lg:justify-between text-center lg:text-left">
        <div className="flex flex-col lg:flex-row items-center justify-center">
          <IconPen />

          <div className="max-w-xl">
            <h2 className="text-white">Ready to become a thought leader?</h2>

            <p className="text-softBlue-200 text-xl leading-7 font-medium mb-10 lg:mb-0">
              Let’s talk. I’ll help you share your best stories, advice,
              lessons, opinions and perspectives in a way that gets attention.
            </p>
          </div>
        </div>

        <ButtonPrimary
          label="Book a call"
          color="green"
          onClick={handleClick}
        />
      </div>
    </div>
  )
}

export default MediumCTA

const IconPen = () => {
  return (
    <svg
      width="78"
      height="100"
      viewBox="0 0 78 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="lg:mr-10 mb-10 lg:mb-0"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 97L58 97L58 94.3152C58.6459 83.1716 64.2753 74.7971 73.7669 71.2117C75.1201 70.7005 76.1856 69.6283 76.6883 68.272C77.191 66.9157 77.0817 65.4081 76.3886 64.1385L43.8886 4.60421C43.0122 2.99875 41.3291 1.99999 39.5 1.99999C37.6709 1.99999 35.9878 2.99875 35.1113 4.60421L2.61135 64.1385C1.91825 65.4081 1.80895 66.9157 2.31169 68.272C2.81444 69.6283 3.87993 70.7005 5.23311 71.2116C15.5668 75.1152 22 84.5406 22 96.5L22 97ZM26.7268 92L53.179 92C54.287 81.8886 59.1877 73.5061 67.4751 68.6805C68.8859 67.859 70.3949 67.1406 72 66.5342L42 11.5796L42 50.7725C47.1492 51.914 51 56.5073 51 62C51 68.3513 45.8513 73.5 39.5 73.5C33.1487 73.5 28 68.3513 28 62C28 56.5073 31.8508 51.914 37 50.7725L37 11.5795L7 66.5342C8.59288 67.1359 10.1066 67.8481 11.5351 68.6618C20.0018 73.4844 25.4774 81.8756 26.7268 92ZM39.5 55.5C35.9102 55.5 33 58.4101 33 62C33 65.5898 35.9102 68.5 39.5 68.5C43.0899 68.5 46 65.5898 46 62C46 58.4101 43.0899 55.5 39.5 55.5Z"
        fill="#74BB9B"
      />
    </svg>
  )
}
